import React from 'react'
import { Table } from 'reactstrap'
var EmptyRow = function (props) {
  return React.createElement('tr', null, React.createElement('td', { colSpan: props.colSpan }, props.children))
}
export function ODListablePaginatedTable2(props) {
  var _a, _b
  var numColumns = props.numColumns,
    renderHeader = props.renderHeader,
    renderRow = props.renderRow,
    listableContext = props.listableContext,
    renderEmpty = props.renderEmpty,
    _c = props.onEvent,
    onEvent =
      _c === void 0
        ? function () {
            return null
          }
        : _c,
    eventParentContext = props.eventParentContext
  var rendererContext = React.useState(function () {
    return {
      onEvent: onEvent,
      parentContext: eventParentContext,
    }
  })[0]
  var _d = React.useContext(listableContext),
    state = _d.state,
    keyExtractor = _d.keyExtractor
  var loading = state.loading,
    list = state.list
  if (loading) {
    return React.createElement(React.Fragment, null, 'Loading...')
  }
  return React.createElement(
    Table,
    { responsive: true, striped: true, style: { marginTop: 0, borderBottom: '1px solid #c8ced2' } },
    React.createElement('thead', null, renderHeader()),
    React.createElement(
      'tbody',
      null,
      list.length > 0 &&
        list.map(function (v) {
          return renderRow(v, rendererContext)
        }),
      list.length === 0 &&
        React.createElement(
          EmptyRow,
          { colSpan: numColumns },
          ((_b = (_a = renderEmpty) === null || _a === void 0 ? void 0 : _a(state)),
          _b !== null && _b !== void 0 ? _b : 'No data.')
        )
    )
  )
}
//# sourceMappingURL=ODListablePaginationTable2.js.map
